import { runTextAnimation } from './text'

function runIntroAnimations()
{
  let $intro = $('.section-intro')
  if (!$intro.length) {
    return
  }

  let run = function () {
    runTextAnimation($intro)
  }

  // Wait until SplitType has created lines (app.js), otherwise the tween is a no-op
  // and the h1 stays at translateY(102%).
  if (!$intro.find('.js-text-animate h1, .js-text-animate .h1').length || $intro.find('.js-line-animate').length) {
    run()
    return
  }

  let n = 0
  let id = setInterval(function () {
    n += 1
    if ($intro.find('.js-line-animate').length || n > 120) {
      clearInterval(id)
      run()
    }
  }, 50)
}

export { runIntroAnimations }
